import { SideItemMenuSectionsName } from '../main/containers/Dashboard/SideNavigationMenu/SideNavigationMenuConfiguration';
import { UserItemMenuSectionsName } from '../main/containers/Dashboard/AppsWrapper/TopMenu/TopMenuConfiguration';
import { hasPermission } from './PermissionsHelper';
import { RoutePermissions } from '../constants/RoutePermissions';
import { User } from '../models/User';
import { ExtendedProducts } from '../models/ExtendedProducts';

export const getNewNotificationsSectionsWithTag = (
    user: User,
    extendedProducts: ExtendedProducts
): Array<UserItemMenuSectionsName | SideItemMenuSectionsName> => {
    const newDisplayedTags: Array<UserItemMenuSectionsName | SideItemMenuSectionsName> = [];

    if (hasPermission({ user, extendedProducts }, RoutePermissions.ShowHomeSection)) {
        newDisplayedTags.push(SideItemMenuSectionsName.HOME);
    }

    return newDisplayedTags;
};
